export type DashboardContextType = 'teams' | 'agents' | 'customers';

export type DashboardContext = {
    type: DashboardContextType;
    objectId: string;
};

export function getDashboardContextFromPath(pathname: string): DashboardContext | null {
    const match = pathname.match(/\/(teams|agents|customers)\/([^/]+)\/dashboard(?:\/|$)/);
    if (!match) {
        return null;
    }

    return {
        type: match[1] as DashboardContextType,
        objectId: match[2],
    };
}

